export const SupportBeamsSpans = [
    /*maxSpan in Metern, thickness in mm*/
    {maxSpan: 2.38, thickness: 100},
    {maxSpan: 2.965, thickness: 120},
    {maxSpan: 3.55, thickness: 140},
    {maxSpan: 4.095, thickness: 160},

    //Übernommen aus Dach Spannweiten je Deckenstärke
    {maxSpan: 7.00, thickness: 180},
    {maxSpan: 7.60, thickness: 200},
    {maxSpan: 8.20, thickness: 220},
    {maxSpan: 8.90, thickness: 240}];
